// extracted by mini-css-extract-plugin
module.exports = {"override":"overlay_override__3KQWL"};